import "../../node_modules/bootstrap/dist/js/bootstrap.bundle";

window.$ = window.jQuery = require("jquery"); // <-- main, not 'slim'
require("jquery-validation");
require("jquery-validation-unobtrusive");
window.Popper = require("popper.js");
require("bootstrap");
window.$rangy = require("rangy");
window.$uuid = require("uuid/v1");
require("maphilight");
window.$copy = require("copy-to-clipboard");
